export const getProductDisplayName = (productName) => {
  if (productName === 'Free Tier' || productName === 'Free Account') {
    return '€1 Starter';
  }
  return productName;
};
